import { render } from "./SearchUsersBoxComp.vue?vue&type=template&id=2d5c6b26&scoped=true"
import script from "./SearchUsersBoxComp.vue?vue&type=script&lang=js"
export * from "./SearchUsersBoxComp.vue?vue&type=script&lang=js"

import "./SearchUsersBoxComp.vue?vue&type=style&index=0&id=2d5c6b26&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5c6b26"]])

export default __exports__